

export default function getProducts(room, austattung_produkt){

    const productList = [];

    if(
        room.selectedEquipment["melden_bewegung"] !== undefined
        && Boolean(room.selectedEquipment["melden_bewegung"])
        && austattung_produkt["praesenzmelder"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["praesenzmelder"],
            count: 1
        })
    }
    return productList;
}
